import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    useColorMode,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    VStack
} from '@chakra-ui/react';
import NotificationSettings from '../NotificationSettings';
import PriceAlerts from '../PriceAlerts';
import { notificationUtils } from '../../utils/notifications';

export const NotificationModal = ({ isOpen, onClose, bitcoinPrice, notificationsEnabled, setNotificationsEnabled }) => {
    const { colorMode } = useColorMode();
    const bgColor = colorMode === 'dark' ? '#121212' : '#ffffff';
    const borderColor = colorMode === 'dark' ? '#ffffff' : '#121212';

    return (
        <Modal isOpen={isOpen} onClose={onClose} size={{ base: "sm", md: "lg" }}>
            <ModalOverlay backgroundColor="rgba(16, 22, 26, 0.9)" />
            <ModalContent bg={bgColor} pb={6} borderWidth="2px" borderStyle="solid" borderColor={borderColor} borderRadius="6px" overflow="hidden">
                <ModalHeader>Notifications</ModalHeader>
                <ModalCloseButton
                    _hover={{
                        bg: 'blue.500',
                        color: 'white',
                    }}
                    _focus={{
                        boxShadow: '0 0 0 1px rgba(66, 153, 225, 0.6)',
                    }}
                />
                <ModalBody>
                    <Tabs colorScheme="orange">
                        <TabList>
                            {/* <Tab>What's New</Tab> */}
                            <Tab>Set Alerts</Tab>
                        </TabList>

                        <TabPanels>
                            {/* <TabPanel>
                                <VStack align="stretch" spacing={4}>
                                    <UnorderedList>
                                        <ListItem mb={3}><strong>🔔 NEW! Push Notifications</strong> <Text fontSize={'12px'}>Get notified when new blocks are mined</Text></ListItem>
                                        <ListItem mb={3}><strong>💹 NEW! Price Alerts</strong> <Text fontSize={'12px'}>Set alerts for Bitcoin price targets</Text></ListItem>
                                        <ListItem mb={3}><strong>FIXED! Dashboard Loading Issues</strong> <Text fontSize={'12px'}>Some users reported a blank page</Text></ListItem>
                                        <ListItem mb={3}><strong>New! Last Six Blocks Display</strong> <Text fontSize={'12px'}>See the most recent Bitcoin blocks</Text></ListItem>
                                    </UnorderedList>
                                    <Text fontSize={'10px'} color={'gray.700'}>TimechainStats version {version}</Text>
                                </VStack>
                            </TabPanel> */}

                            <TabPanel>
                                <VStack align="stretch" spacing={4} mt={4}>
                                    <NotificationSettings 
                                        permission={notificationUtils.getPermissionStatus()}
                                        enabled={notificationsEnabled}
                                        onToggle={setNotificationsEnabled}
                                        onClose={onClose}
                                    />
                                    <PriceAlerts currentPrice={bitcoinPrice} notificationsEnabled={notificationsEnabled} />
                                </VStack>
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};